import styled from "styled-components";

export const warningStyles = {
  copy: {
    display: "flex",
    padding: "3px",
  },
  modelParent: {
    position: "fixed" /* Stay in place */,
    zIndex: "9" /* Sit on top */,
    left: 0,
    top: 0,
    width: "100%" /* Full width */,
    height: "100%" /* Full height */,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  modelOverLay: {
    position: "fixed" /* Stay in place */,
    left: 0,
    top: 0,
    width: "100%" /* Full width */,
    height: "100%" /* Full height */,
    backgroundColor: "rgba(0,0,0,0.2)" /* Black w/ opacity */,
  },
  modalCont: {
    backgroundColor: "#fefefe",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    zIndex: "99",
    boxSizing: "border-box",
    height: "645px",
    width: "588px",
    overflow: "scroll",
    padding: "34px 24px 24px 24px",
    boxShadow: "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
  },
  title: {
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "20px",
    textAlign: "center",
    letterSpacing: "0.23px",
    color: "#000000",
  },
  buttonGroup: { 
    justifyContent: "flex-end",
    height: "56px", 
    display: "flex" 
  },
  popOutBody: {
    fontFamily: '"Open Sans", sans-serif',
    fontSize: "13px",
    lineHeight: "160%",
    letterSpacing: "0.23px",
    color: "#51636F",
    marginTop: "16px",
  },
  closeIcon: { position: "relative", left: "115px", top: "-15px" },
  titleCon: { display: "flex", marginRight: "12px" },
  header: { display: "flex", alignItems: "center", width: "100%" },
  model: {
    width: "374px",
    height: "auto",
    overflow: "hidden",
    padding: "24px 20px 20px 24px",
  },
};

export const cnfButton = {
  cancelStyle: {
    marginBottom: "0",
    marginRight: "14px",
    marginTop: "26px",
  },
  cnfTxtStyle: {
    marginBottom: "0",
    marginRight: "0",
    marginTop: "26px",
    textTransform: "none"
  },
};

export const zapStyles = {
 
};

export const CloseIconWrapper = styled.div`
  border-radius: 50%;
  &:hover {
    background: #e2f1ff;
  }
`;
